<template>
    <dashlet-card :page-tooltip="t_page_tooltip_journal"
                  :title="t_title"
                  page-href="/system/journal">
        <template #prependButton>
            <square-button :disabled="loading"
                           :loading="loading"
                           :tooltip-text="t_refresh_tooltip"
                           flat
                           icon="far fa-arrows-rotate"
                           @click="fetchEntries" />
        </template>

        <div v-if="error"
             class="ibox-content">
            <div class="load-journal-notifications">
                <div class="alert alert-danger"
                     style="margin-bottom: 0;">
                    {{ t_load_fail }}
                </div>
            </div>
        </div>

        <loading-placeholder v-if="loading && !anyEntries" />

        <div v-else-if="anyEntries"
             class="table-container">
            <table class="table journal-table">
                <thead>
                <tr>
                    <th class="sorting_disabled">{{ t_date }}</th>
                    <th class="sorting_disabled">{{ t_module }}</th>
                    <th class="sorting_disabled">{{ t_action }}</th>
                    <th class="sorting_disabled">{{ t_user }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="entry in entries">
                    <td>{{ entry.created_at }}</td>
                    <td>{{ entry.module_id }}</td>
                    <td>{{ entry.action }}</td>
                    <td>{{ entry.user_id }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else
             class="dashlet-message-container">
            {{ noEntriesMessage }}
        </div>
    </dashlet-card>
</template>

<script>
import DashletCard from './dashlet-card.vue'
import SquareButton from '../../content/common/squareButton.vue'
import LoadingPlaceholder from '../../content/common/loadingPlaceholder.vue'
import {FormatDateTimeEntryToLocaleString} from "../../../../utils/date";

export default {
    components: {
        LoadingPlaceholder,
        SquareButton,
        DashletCard
    },
    props: {
        showCount: Number
    },
    data() {
        return {
            t_title: Lang.langGet('Recent Activities'),
            t_page_tooltip_journal: Lang.langGet('Journal'),
            t_refresh_tooltip: Lang.langGet('Reload'),

            t_load_fail: Lang.langGet('Failed to load Journal entries!'),
            t_date: Lang.langGet('Date'),
            t_module: Lang.langGet('Module'),
            t_action: Lang.langGet('Action'),
            t_user: Lang.langGet('User'),

            entries: [],
            loading: true,
            error: false
        }
    },
    methods: {
        fetchEntries() {
            this.loading = true
            this.error = false
            axios.post('/dashboard/journal/get', {
                id: Laravel.activeProject,
                count: this.showCount
            }).then((response) => {
                // success callback
                this.error = false
                this.entries = response.data
                this.entries.forEach((entry) => {
                    entry.created_at = FormatDateTimeEntryToLocaleString(entry.created_at);
                })
            }, (error) => {
                // error callback
                this.error = error
                this.entries = []
            }).finally(() => {
                this.loading = false
            })
        }
    },
    computed: {
        anyEntries() {
            return this.entries?.length > 0
        },
        noEntriesMessage() {
            return `0 ${Lang.langGet('entries')}`
        }
    },
    created() {
        this.fetchEntries()
    }
}

</script>
